import React from 'react'

function PrivacyPolicy (){
    return (
        <div className="Body-Content">
            <h1>Privacy Policy</h1>
            <div className="BodyParagraphs">
                <p>
                    This privacy policy is a default policy for Ryan Caigoy LLC software applications.
                    <br />
                    That being said, any applications using this privacy policy will not store any 
                    information from any users other than those with specific Non Disclosure Agreement 
                    Contracts with Ryan Caigoy LLC.
                    <br />
                    Apps using this privacy policy are for testing apps developed by Ryan Caigoy LLC.
                    We will only store personal data from Ryan Caigoy LLC.
                    <br />
                    We will implement tests with api from other companies including but not limited
                    to:  Facebook, Instagram, and twitter.
                </p>
                <p>
                    -Ryan Caigoy (Ryan Caigoy LLC)
                </p>
            </div>
        </div>
    )
}

export default PrivacyPolicy